module.exports = __webpack_public_path__ + "img/Feature.0cf09194.jpg";